import $ from 'jquery';
import {refreshExcludedCounter} from './excludeCounter';

// Фильтры на странице исключения продуктов.
//
// Два списка с множественным выбором сужают то, что видно на экране:
// типы продуктов и непереносимости.
//
// Внутри списка — ИЛИ: выбрал «Фрукты» и «Овощи» — видишь и то, и другое,
// иначе множественный выбор не имел бы смысла. Между списками — И:
// «молочные, в которых есть лактоза». Сначала было ИЛИ по всему, но при
// работе выяснилось, что это сбивает: к выбранной группе подмешивались
// чужие продукты (решение 27.09).
//
// Сами продукты фильтр не исключает, это делает человек галочкой
// или кнопкой «Выбрать все».
//
// Раскладкой сетки занимается isotope, поэтому прятать карточки своими
// руками нельзя: позиции у неё абсолютные, и в сетке остались бы дыры.
// Отдаём ей свою функцию отбора.

const SELECTED_LABEL = 'Выбрано';

export function initExcludeFilters() {
    const $groups = $('#filterGroups');
    const $flags = $('#filterFlags');
    if (!$groups.length && !$flags.length) return;

    // Плагин multiselect живёт на глобальном jQuery страницы (3.5.1),
    // а у сборки своя копия (3.6.0). События одной копии не доходят
    // до обработчиков другой — см. activity.js. Через
    // document.defaultView, потому что window.jQuery webpack подменяет
    // на копию из сборки.
    const $global = document.defaultView['jQuery'] || $;

    function selected($select) {
        const value = $select.val();
        return Array.isArray(value) ? value : (value ? [value] : []);
    }

    function matches(element) {
        const groups = selected($groups);
        const flags = selected($flags);
        const search = ($('#quicksearch').val() || '').trim().toLowerCase();

        if (search) {
            const title = (element.textContent || '').toLowerCase();
            if (title.indexOf(search) === -1) return false;
        }
        if (groups.length) {
            const group = element.getAttribute('data-group') || '';
            if (groups.indexOf(group) === -1) return false;
        }
        if (flags.length) {
            const own = (element.getAttribute('data-flags') || '').split(' ');
            if (!flags.some(flag => own.indexOf(flag) !== -1)) return false;
        }
        return true;
    }

    // Какие продукты заберёт «Выбрать все». Показываем мы больше,
    // чем исключаем: продукты, где элемент только «возможно»,
    // остаются человеку — он берёт их с маркировкой «без глютена»,
    // а в составе блюда под ними стоит «проверьте упаковку»
    // (решение владельца 21.10).
    function willExclude(element) {
        if (!matches(element)) return false;
        const flags = selected($flags);
        if (!flags.length) return true;
        const sure = (element.getAttribute('data-flags-sure') || '').split(' ');
        return flags.some(flag => sure.indexOf(flag) !== -1);
    }

    const $grid = $global('.grid');

    function applyFilter() {
        if ($grid.length && $grid.isotope) {
            $grid.isotope({ filter: function () { return matches(this); } });
        }
        const shown = $('.element-item').filter(function () { return matches(this); }).length;
        const sure = $('.element-item').filter(function () { return willExclude(this); }).length;
        const hasFilter = selected($groups).length > 0 || selected($flags).length > 0;

        // Обе кнопки нужны только при выбранном фильтре: без него
        // «Исключить все» означало бы «исключить всё вообще».
        $('#excludeShown').toggleClass('d-none', !hasFilter);
        $('#resetFilters').toggleClass('d-none', !hasFilter);
        $('#excludeShown').text(`Выбрать все · ${sure}`);
        $('#excludeEmpty').toggleClass('d-none', shown > 0);

        // Иначе «Выбрать все · 18» при 27 карточках на экране читается
        // как сбой. Объясняем разницу там же, где она видна.
        const left = shown - sure;
        $('#excludeMaybeNote')
            .toggleClass('d-none', !hasFilter || left < 1)
            .text(left === 1
                ? 'Ещё один продукт оставлен: элемент в нём возможен, но не обязателен — проверьте упаковку'
                : `Ещё ${left} продукта оставлены: элемент в них возможен, но не обязателен — проверьте упаковку`);
    }

    function optionLabel(element) {
        const option = $global(element);
        const title = option.text();
        const count = option.attr('data-count') || '';
        const soon = option.attr('data-soon')
            ? '<span class="option-soon">Скоро</span>'
            : '';
        return `<span class="option-title">${escapeHtml(title)}</span>${soon}`
            + `<span class="option-count">${escapeHtml(count)}</span>`;
    }

    function escapeHtml(text) {
        return String(text === undefined || text === null ? '' : text)
            .replace(/[&<>"']/g, ch => ({
                '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
            }[ch]));
    }

    function buttonText(options) {
        return options.length ? `${SELECTED_LABEL} ${options.length}` : 'Не выбрано';
    }

    $global('.exclude-filter').each(function () {
        const $select = $global(this);
        const $wrapper = $global(this).closest('.exclude-filters__select');
        if (!$select.multiselect) {
            // Скрипт плагина не загрузился: показываем родной список,
            // иначе фильтр остался бы недоступным вовсе.
            $wrapper.addClass('exclude-filters__select--plain');
            return;
        }
        $select.multiselect({
            includeSelectAllOption: false,
            enableHTML: true,
            buttonText,
            buttonTitle: buttonText,
            optionLabel,
            maxHeight: 420,
            nonSelectedText: 'Не выбрано',
        });
        // Поле отрисовано плагином — убираем заглушку.
        $wrapper.addClass('exclude-filters__select--ready');
    });

    // Выбор приходит через глобальный jQuery, ввод в поиске — обычным
    // событием. Слушаем оба.
    $global(document).on('change', '.exclude-filter', applyFilter);
    document.addEventListener('change', (event) => {
        if (event.target && event.target.classList
            && event.target.classList.contains('exclude-filter')) {
            applyFilter();
        }
    });
    $('#quicksearch').on('keyup', applyFilter);

    // Отмечает всё, что сейчас показано. Не сохраняет: сохранение
    // по-прежнему на кнопке внизу страницы.
    $('#excludeShown').on('click', function () {
        $('.element-item').each(function () {
            if (!willExclude(this)) return;
            const input = this.querySelector('.exclude-product__input');
            if (input && !input.checked) input.checked = true;
        });
        refreshExcludedCounter($);
    });

    $('#resetFilters').on('click', function () {
        $global('.exclude-filter').each(function () {
            const $select = $global(this);
            $select.val([]);
            if ($select.multiselect) $select.multiselect('refresh');
        });
        applyFilter();
    });

    applyFilter();
}
